module.exports = __webpack_public_path__ + "static/media/music-cover-mobile.c8800ca3.jpg";